import { CallChaining, FormFieldWidget, http, ModelFieldType, SPI, ViewType, Widget } from '@kunlun/dependencies';
import {
  lodopHtmlBarCode,
  lodopHtmlA4,
  lodopHtmlTwoPart,
  lodopHtmlThirdPart,
  lodopHtmlTradeOrderTwoPart,
  lodopHtmlTradeOrderThirdPart,
  lodopHtmlTradeOrderA4,
  lodopPDFBarCode
} from '../../../util/lodopFdfBase64';
import PrintHTMLFile from './PrintHTMLFile.vue';

interface ISizeOption {
  id: number;
  name: string;
  width: string;
  height: string;
}

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Detail,
    ttype: ModelFieldType.String,
    widget: 'printHTMLFile',
    multi: false
  })
)
export class DetailStringPrintHTMLFileFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(PrintHTMLFile);
    return this;
  }

  @Widget.Reactive()
  printSizeOptions: ISizeOption[] = [];

  @Widget.Reactive()
  public get isDisabled() {
    return this.formData.isXAsyncPrint || this.formData.isSingleQrCode;
  }

  @Widget.Reactive()
  @Widget.Inject()
  protected mountedCallChaining: CallChaining | undefined;

  protected mounted() {
    super.mounted();
    if (this.mountedCallChaining) {
      this.mountedCallChaining.hook(this.path, async () => {
        await this.mountedProcess();
      });
    } else {
      this.mountedProcess();
    }
  }

  protected mountedProcess(): void {
    if (this.formData.isXAsyncPrint || this.formData.isSingleQrCode) {
      this.printSizeOptions = [
        {
          id: 5,
          name: '卡片60*30',
          width: '60mm',
          height: '30mm'
        }
      ];
    } else {
      this.printSizeOptions = [
        {
          id: 1,
          name: '2等分',
          width: '220mm',
          height: '140mm'
        },
        {
          id: 2,
          name: '3等分',
          width: '220mm',
          height: '90mm'
        },
        {
          id: 4,
          name: 'A4',
          width: '210mm',
          height: '297mm'
        }
      ];
    }
  }

  @Widget.Method()
  async doPrint(pageId) {
    const page = this.printSizeOptions.find((i) => i.id === pageId);
    if (this.formData.isXAsyncPrint) {
      if (page!.id === 5) {
        try {
          // const requestOptions = {
          //   method: 'GET',
          //   responseType: 'text/html'
          //   // redirect: 'follow'
          // };

          // const res = await fetch(`${this.formData.fileUrl}`, requestOptions);
          // const text = await res.text();
          // lodopHtmlBarCode(text);
          lodopPDFBarCode(this.formData.fileUrl);

          // await this.reordPrint({ id: this.formData.id, exhibitCode: this.formData.printItem[0].exhibitionCode, isBatch: true });
          await this.reordPrint({ id: this.formData.id, exhibitCode: null, isBatch: true });
        } catch (error) {
          console.error(error);
        }
      }
    } else if (this.formData.isSingleQrCode) {
      if (page!.id === 5) {
        lodopPDFBarCode(this.formData.html);
        await this.reordPrint({ id: this.formData.exhibitItemId, exhibitCode: this.formData.exhibitionCode });
      }
    } else if (!this.formData.isTradeOrder) {
      if (page!.id === 4) {
        lodopHtmlA4(this.formData.htmlA4 as string);
      } else if (page!.id === 2) {
        lodopHtmlThirdPart(this.formData.html as string);
      } else {
        lodopHtmlTwoPart(this.formData.html as string);
      }
    } else if (page!.id === 4) {
      lodopHtmlTradeOrderA4(this.formData.html);
    } else if (page!.id === 2) {
      lodopHtmlTradeOrderThirdPart(this.formData.html);
    } else {
      lodopHtmlTradeOrderTwoPart(this.formData.html);
    }
  }

  async reordPrint({ id, exhibitCode, isBatch = false }) {
    const gql = `
      mutation {
        deliAriesMerchantExhibitItemMutation {
          isPrint(
            ${!isBatch ? `exhibitItemIds: ${id}` : `printTaskId: ${id}`}
            exhibitCode: "${exhibitCode}"
          )
        }
      }
    `;
    await http.mutate('deliAriesMerchantExhibitItemMutation', gql);
  }
}
